Mmg.addShortcode(

    /**
     * @param {string} shortcodeName The name of the shortcode
     * @param {string} selector The selector used to locate this shortcode in the DOM
     * @param {callable} callback The callback function applied to every element matching the selector
     */
    'table',
    '.sc-table',
  
    /**
     *
     * Shortcode callback
     *
     * The shortcode callback receives the following parameters:
     *
     * @param {Element} el The shortcode's DOM element
     * @param {object} model The data model passed to the shortcode instance in data-json attribute
     * @param {jQuery} $ The callback function applied to every element matching the selector
     * @param {string} selector The shortcode selector that was passed to addShortcode
     * @param {string} className The name of the shortcode class
     */
    (el, model, $, selector, className) => {
  
    // Widget Declarations
    const $this = $(el);
    const $facility = $this.find(`${selector}__facility`);

    (function init(){
        addEvents();
    })();


    /**
     * Add click listeners
     */
    function addEvents(){
        $facility.on('click', `${selector}__facility-name`, toggleFacilityInfo);
    }


    /**
     * Toggle visibility of the facility info
     * @param {*} event 
     */
    function toggleFacilityInfo(event){
        const $target = $(event.delegateTarget);
        $target.toggleClass(`${className}__facility--open`);
    }
  
  });
  